import { hdmgdjStats } from "@/mocks/hdmgdj/stats";

export default function HdmgdjStats() {
  return (
    <section className="w-full bg-background-50 border-b border-background-200">
      <div className="hdmgdj-container py-12 md:py-14">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-9">
          {hdmgdjStats.map((stat, index) => (
            <div
              key={stat.id}
              className={`hdmgdj-reveal flex flex-col items-center text-center ${
                index % 2 === 1 ? "border-l border-background-200" : ""
              } ${index === 2 ? "lg:border-l lg:border-background-200" : ""}`}
              style={{ transitionDelay: `${index * 60}ms` }}
            >
              <span className="font-heading text-[32px] md:text-[42px] leading-none text-foreground-950">
                {stat.value}
              </span>
              <span className="mt-3 inline-flex items-center gap-2 text-[13px] md:text-[14px] font-label text-foreground-500">
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500" />
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}